import React from 'react'
import { Text, Icon } from 'components/'
import classNames from 'classnames'
import styles from './Discount.module.scss'

const Discount = ({
  show = true,
  percent = null,
  withIcon = false,
  fontSize = 'regular',
}) => {
  if (!percent) {
    return null
  }

  return (
    show && (
      <span className={styles.discount}>
        <span>
          <span>
            <Text
              className={withIcon ? styles.text : ''}
              fontSize={withIcon ? 'small' : 'medium'}
            >
              Deságio
            </Text>
          </span>
        </span>

        <span>
          <span>
            <p
              className={classNames(
                styles.percent,
                styles[withIcon ? 'medium' : 'large'],
                fontSize && styles[fontSize]
              )}
            >
              {`${percent}%`}
            </p>
          </span>
          <Icon
            type="down"
            size={16}
            color="secondColor"
            style={{ marginBottom: 3 }}
          />
        </span>
      </span>
    )
  )
}

export default React.memo(Discount)
